import { ReactElement } from 'react';
import { Container } from '@mui/material';

import {
  DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS,
  LIQUID_STAKING_TOKEN_ADDRESS,
} from 'modules/api/const';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { featureConfig } from 'modules/common/featureConfig';
import { useHasDeprecatedLSToken } from 'modules/deprecatedLiquidStaking/hooks/useHasDeprecatedLSToken';
import { LiquidStakingPoolContext } from 'modules/liquidStaking/LiquidStakingPoolContext';

import { DelegateStaking } from '../components/DelegateStaking';
import { LiquidStakingSection } from '../components/LiquidStakingSection';
import { TotalStaked } from '../components/TotalStaked';

export function Dashboard(): ReactElement {
  const { hasTokens: hasDeprecatedToken, hasPendingUnstakes } =
    useHasDeprecatedLSToken();
  const { isConnected } = useConnection();

  return (
    <Container
      maxWidth={false}
      sx={{ maxWidth: 808, display: 'flex', flexDirection: 'column', gap: 4.5 }}
    >
      <TotalStaked />

      <DelegateStaking />

      {featureConfig.isLiquidStakingEnabled && (
        <>
          <LiquidStakingPoolContext.Provider
            value={LIQUID_STAKING_TOKEN_ADDRESS}
          >
            <LiquidStakingSection />
          </LiquidStakingPoolContext.Provider>

          {(hasDeprecatedToken || hasPendingUnstakes) && isConnected && (
            <LiquidStakingPoolContext.Provider
              value={DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS}
            >
              <LiquidStakingSection />
            </LiquidStakingPoolContext.Provider>
          )}
        </>
      )}
    </Container>
  );
}
